import {backAdmin} from "../axios";

export const dashboardApi = [
    {url: `${backAdmin}/dashboard`, name: 'dashboard.all', method: 'GET'},
]